import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=4250fcde&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=4250fcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250fcde",
  null
  
)

export default component.exports